var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-page',[_c('app-secondary-header',{attrs:{"title":"Support"}}),_c('ion-content',[_c('ion-list',{staticClass:"ion-padding"},[_vm._v(" No support page at this time ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }